<template>
    <div class="literacyAssessmentDetial">
        <!-- default-expand-all -->
        <el-table
            row-key="key"
            :tree-props="{ children: 'chirldren', hasChildren: 'hasChildren' }"
            :data="tableData"
            style="
                width: 100%;
                margin-top: 20px;
                flex: 1;
                border: 1px solid #f2f4f7;
                border-radius: 4px;
            "
            size="medium"
            :header-cell-style="{
                fontWeight: 'normal',
                color: '#333',
                background: '#f5f7fa',
            }"
            class="table-content"
            :cell-style="{ fontSize: '12px', color: '#333' }"
        >
            <el-table-column prop="name" label="细项名称"> </el-table-column>
            <el-table-column prop="address" label="操作" width="230">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="!scope.row.parent_key"
                        :disabled="scope.row.chirldren.length >= 4"
                        @click="newRegulation(scope.row.key)"
                    >
                        新建二级细项
                    </el-button>
                    <el-button type="text" v-if="scope.row.is_default === 0" @click="editLiteracy(scope.row)">编辑</el-button>
                    <el-button
                        type="text"
                        class="primary-delete"
                        v-if="scope.row.is_default === 0"
                        @click="deleteLiteracy(scope.row.key, !!scope.row.parent_key ? false : true)"
                    >
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                :current-page="pageParams.page"
                :page-size="pageParams.size"
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next, total"
                :total="pageParams.total"
            >
            </el-pagination>
        </div>

        <el-dialog
            :title="dialogData.dialogTitle"
            :visible.sync="dialogData.visible"
            width="30%"
            style="border-radius: 10px"
            :before-close="cancel"
        >
            <el-form :model="ruleForm" :rules="rules" ref="ruleFormRef" label-width="100px" class="demo-ruleForm">
                <el-form-item label="细则名称" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="2-18字" maxlength="18" show-word-limit></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="cancel">取 消</el-button>
                <el-button size="medium" type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [],
            pageParams: {
                paging: 1,
                page: 1,
                size: 10,
                total: 0,
            },
            total: 0,
            dialogData: {
                visible: false,
                type: 1, // 弹框类型，1-新建，2-编辑
                level: 1, // 细则等级, 1-一级细则, 2-二级细则
                parent_key: "", // 父级key-level为2时使用
                key: "", // 素养key，编辑时使用
                dialogTitle: "新建细项",
            },
            ruleForm: {
                name: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入细项名称",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 18,
                        message: "细项名称限制为2-18个字符",
                        trigger: "blur",
                    },
                ],
            },
            selectRow: {},
        };
    },
    mounted() {
        this.getLiteracyAssessmentList();
    },
    methods: {
        // 获取细则列表
        getLiteracyAssessmentList() {
            const params = {
                c_id: Number(localStorage.getItem("class_id")),
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(localStorage.getItem("teacherChapter")),
                course_node: Number(localStorage.getItem("teacherNode")),
                paging: this.pageParams.paging,
                page: this.pageParams.page,
                limit: this.pageParams.size,
            };
            console.log("get detail: ", params);

            this.$shttp.axiosGetBy(this.$api.literacy_rules, params, (res) => {
                if (res.code === 200) {
                    this.tableData = res.data.list || [];
                    this.pageParams.total = res.data.total;
                }
            });
        },

        // 新建细则
        newRegulation(parentKey = "") {
            if (parentKey) {
                // 创建二级细则
                this.dialogData.dialogTitle = "新建二级细项";
                this.dialogData.level = 2;
                this.dialogData.parent_key = parentKey;
            } else {
                // 创建一级细则
                this.dialogData.dialogTitle = "新建细项";
                this.dialogData.level = 1;
            }

            this.dialogData.type = 1;
            this.dialogData.visible = true;
        },

        editLiteracy(row) {
            if (row.parent_key) {
                // 编辑二级细则
                this.dialogData.dialogTitle = "编辑二级细项";
                this.dialogData.level = 2;
                this.dialogData.parent_key = row.parent_key;
            } else {
                // 编辑一级细则
                this.dialogData.dialogTitle = "编辑细项";
                this.dialogData.level = 1;
            }

            this.ruleForm.name = row.name;
            this.dialogData.key = row.key;
            this.dialogData.type = 2;
            this.dialogData.visible = true;
        },

        deleteLiteracy(key, isParent) {
            this.$confirm("是否删除细则?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                customClass: "initial-message-box",
            }).then(() => {
                const formData = new FormData();
                formData.append("course_id", Number(this.$route.query.course_id));
                formData.append("course_chapter", Number(localStorage.getItem("teacherChapter")));
                formData.append("course_node", Number(localStorage.getItem("teacherNode")));
                formData.append("c_id", Number(localStorage.getItem("class_id")));
                formData.append("key", key);

                this.$shttp.axiosPost(this.$api.delete_literacy_rules, formData, (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);

                        if (isParent) {
                            // 删除一级细则需要判断是否换页
                            if ((this.pageParams.total - 1) / this.pageParams.size <= this.pageParams.page) {
                                this.pageParams.page -= 1;
                            }
                        }

                        this.getLiteracyAssessmentList();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },

        confirm() {
            this.$refs.ruleFormRef?.validate((valid) => {
                if (valid) {
                    const formData = new FormData();
                    formData.append("name", this.ruleForm.name);
                    formData.append("level", this.dialogData.level);
                    formData.append("c_id", Number(localStorage.getItem("class_id")));
                    formData.append("course_id", Number(this.$route.query.course_id));
                    formData.append("course_chapter", Number(localStorage.getItem("teacherChapter")));
                    formData.append("course_node", Number(localStorage.getItem("teacherNode")));

                    if (this.dialogData.level === 2) formData.append("parent_key", this.dialogData.parent_key);
                    if (!!this.dialogData.key) formData.append("key", this.dialogData.key);

                    this.$shttp.axiosPost(this.$api.save_literacy_rules, formData, (res) => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);
                            this.cancel();
                            this.getLiteracyAssessmentList();
                        } else {
                            this.$message.warning(res.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        cancel() {
            // 清空弹框数据
            this.dialogData.visible = false;
            this.dialogData.parent_key = "";
            this.dialogData.key = "";

            // 清空表单数据
            this.ruleForm = {
                name: "",
            };
            this.$refs.ruleFormRef?.resetFields();
        },
        handleCurrentChange(val) {
            this.pageParams.page = val;
            this.getLiteracyAssessmentList();
        },
    },
};
</script>

<style scoped lang="scss">
.literacyAssessmentDetial {
    .primary-delete {
        color: #ff0000;
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
    }
}

::v-deep .el-button.is-disabled {
    color: rgba(64, 158, 255, 0.7);
}

::v-deep .el-input__inner {
    background: #fff !important;
}

::v-deep .el-dialog {
    margin: 0 !important;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>
